import React from "react";
import {observer} from "mobx-react-lite";
import {FormControlLabel, Switch, Typography} from "@mui/material";
import {useStores} from "~/stores";

/** The "By parent supplier" switch in the card headers */
export const ByParentSupplierSwitch: React.FC<{label: string}> = observer(({label}) => {
    const {bagStore} = useStores();
    return <FormControlLabel
        className="spend-landscape-switch"
        labelPlacement="end"
        control={<Switch
            size="small"
            checked={bagStore.advanced.groupParentSuppliersFilter}
            onChange={(_e, checked) => bagStore.advanced.groupParentSuppliersFilter = checked}/>}
        label={<Typography variant="body2">{label}</Typography>}/>;
});
